import React from "react";
import { inject, observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { Colors, HexColors } from "../../Utils/colors";
import { Popconfirm } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import headerlogo from "../../Assets/HeaderLogo.svg";
import "./styles/Doctorsidebar.css";

const Doctorsidebar = inject("store")(
  observer(({ store, user }) => {
    const history = useHistory();
    // const [visible, setVisible] = useState(false);
    const doctor = user;

    // const showDoctorDrawer = () => {
    //     setVisible(!visible);
    // };
    // const onClose = () => {
    //     setVisible(false);
    // };
    console.log(doctor);

    function confirm(e) {
      console.log(e);
      history.push("/login");
      localStorage.clear();
    }

    function cancel(e) {
      console.log(e);
    }
    return (
      <div>
        <div className="sidebar-doctor">
          <div
            style={{
              border: "1px solid #FAF2F2",
              padding: "auto",
              cursor: "pointer",
            }}
            onClick={() => history.push("/doctorhome")}
          >
            <img className="logo" src={headerlogo} alt="logo" />
          </div>
          <div
            className="box"
            style={{
              backgroundColor:
                store.color === Colors.allopathic
                  ? "#F5F5FF"
                  : store.color === Colors.homeopathic
                  ? "#EFF6FF"
                  : "#EFFCFF",
            }}
          >
            <div
              onClick={() => {
                // onClose()
                history.push("/doctorprofile", { user: doctor });
              }}
              className="content flex pt-6"
            >
              <p className="svg">
                <svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.294 5.29105C13.294 8.22808 10.9391 10.5831 8 10.5831C5.0619 10.5831 2.70601 8.22808 2.70601 5.29105C2.70601 2.35402 5.0619 0 8 0C10.9391 0 13.294 2.35402 13.294 5.29105ZM8 20C3.66237 20 0 19.295 0 16.575C0 13.8539 3.68538 13.1739 8 13.1739C12.3386 13.1739 16 13.8789 16 16.599C16 19.32 12.3146 20 8 20Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p
                className="cursor-pointer"
                // onClick={() => {
                //     onClose();
                // }}
              >
                My Profile
              </p>
            </div>
            <div
              onClick={() => history.push("/community", { user: doctor })}
              className="flex content"
            >
              <p className="svg">
                <svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1583 4.23285C15.1583 6.58254 13.2851 8.4666 10.949 8.4666C8.61292 8.4666 6.73974 6.58254 6.73974 4.23285C6.73974 1.88227 8.61292 0 10.949 0C13.2851 0 15.1583 1.88227 15.1583 4.23285ZM10.949 16C7.51785 16 4.58809 15.456 4.58809 13.2802C4.58809 11.1034 7.49904 10.5396 10.949 10.5396C14.3802 10.5396 17.31 11.0836 17.31 13.2604C17.31 15.4362 14.399 16 10.949 16ZM16.9571 4.30922C16.9571 5.50703 16.5998 6.62288 15.973 7.55051C15.9086 7.64597 15.9659 7.77476 16.0796 7.79457C16.2363 7.82159 16.3984 7.8369 16.5631 7.8414C18.2062 7.88463 19.6809 6.82102 20.0883 5.21974C20.6918 2.84123 18.9198 0.705896 16.6634 0.705896C16.4181 0.705896 16.1835 0.732013 15.9551 0.778845C15.9238 0.78605 15.8907 0.800459 15.8728 0.828378C15.8513 0.862601 15.8674 0.908532 15.8889 0.938252C16.5667 1.8938 16.9571 3.05918 16.9571 4.30922ZM19.6782 9.51257C20.7823 9.72962 21.5084 10.1727 21.8093 10.8166C22.0636 11.3453 22.0636 11.9586 21.8093 12.4864C21.349 13.4851 19.8654 13.8058 19.2887 13.8886C19.1696 13.9066 19.0738 13.8031 19.0864 13.6833C19.3809 10.9157 17.0377 9.60353 16.4315 9.30183C16.4055 9.28832 16.4002 9.2676 16.4028 9.255C16.4046 9.24599 16.4154 9.23158 16.4351 9.22888C17.7468 9.20456 19.1571 9.38468 19.6782 9.51257ZM5.43711 7.84131C5.60186 7.83681 5.76304 7.8224 5.92063 7.79448C6.03434 7.77467 6.09165 7.64588 6.02718 7.55042C5.4004 6.62279 5.04313 5.50694 5.04313 4.30913C5.04313 3.05909 5.43353 1.89371 6.11135 0.938162C6.13284 0.908442 6.14806 0.862511 6.12746 0.828288C6.10956 0.80127 6.07553 0.78596 6.04509 0.778755C5.81586 0.731923 5.58127 0.705806 5.33593 0.705806C3.07951 0.705806 1.30751 2.84114 1.91191 5.21965C2.31932 6.82093 3.79405 7.88454 5.43711 7.84131ZM5.59694 9.25446C5.59962 9.26796 5.59425 9.28778 5.56918 9.30219C4.9621 9.60389 2.61883 10.9161 2.91342 13.6827C2.92595 13.8034 2.83104 13.9061 2.71195 13.889C2.13531 13.8061 0.651629 13.4855 0.191392 12.4867C-0.0637974 11.9581 -0.0637974 11.3457 0.191392 10.817C0.492248 10.1731 1.21752 9.72998 2.32156 9.51203C2.84358 9.38504 4.25294 9.20492 5.5656 9.22924C5.5853 9.23194 5.59515 9.24635 5.59694 9.25446Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p style={{ marginLeft: "15px" }} className="cursor-pointer">
                Community
              </p>
            </div>
            <div
              onClick={() => history.push("/community", { user: doctor })}
              className="flex content"
              // style={{ alignItems: "center" }}
            >
              <p className="svg">
                <svg
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.54951 11.73H11.2624C11.6683 11.73 12.005 11.4 12.005 10.99C12.005 10.57 11.6683 10.24 11.2624 10.24H9.54951V8.51C9.54951 8.1 9.22277 7.77 8.81683 7.77C8.41089 7.77 8.07426 8.1 8.07426 8.51V10.24H6.37129C5.96535 10.24 5.62871 10.57 5.62871 10.99C5.62871 11.4 5.96535 11.73 6.37129 11.73H8.07426V13.46C8.07426 13.87 8.41089 14.2 8.81683 14.2C9.22277 14.2 9.54951 13.87 9.54951 13.46V11.73ZM16.3381 7.02561C16.5708 7.02292 16.8242 7.02 17.0545 7.02C17.302 7.02 17.5 7.22 17.5 7.47V15.51C17.5 17.99 15.5099 20 13.0446 20H5.17327C2.59901 20 0.5 17.89 0.5 15.29V4.51C0.5 2.03 2.5 0 4.96535 0H10.2525C10.5099 0 10.7079 0.21 10.7079 0.46V3.68C10.7079 5.51 12.203 7.01 14.0149 7.02C14.4381 7.02 14.8112 7.02316 15.1377 7.02593C15.3917 7.02809 15.6175 7.03 15.8168 7.03C15.9578 7.03 16.1405 7.02789 16.3381 7.02561ZM16.61 5.5662C15.7961 5.5692 14.8367 5.5662 14.1466 5.5592C13.0516 5.5592 12.1496 4.6482 12.1496 3.5422V0.9062C12.1496 0.4752 12.6674 0.2612 12.9635 0.5722C13.4995 1.1351 14.2361 1.90891 14.9693 2.67913C15.7002 3.44689 16.4277 4.21108 16.9496 4.7592C17.2387 5.0622 17.0268 5.5652 16.61 5.5662Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p className="cursor-pointer">Patients under care</p>
            </div>
            <div className="flex content">
              <p className="svg">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.8204 20H8.18037C7.9523 20 7.73107 19.9221 7.55337 19.7792C7.37567 19.6362 7.25218 19.4368 7.20337 19.214L6.79637 17.33C6.25343 17.0921 5.73861 16.7946 5.26137 16.443L3.42437 17.028C3.20694 17.0973 2.97232 17.0902 2.75949 17.0078C2.54666 16.9254 2.36842 16.7727 2.25437 16.575L0.430373 13.424C0.317518 13.2261 0.275155 12.9958 0.310215 12.7708C0.345275 12.5457 0.455682 12.3392 0.623373 12.185L2.04837 10.885C1.98357 10.2961 1.98357 9.70189 2.04837 9.113L0.623373 7.816C0.455444 7.66177 0.344887 7.45507 0.309822 7.22978C0.274756 7.00449 0.317262 6.77397 0.430373 6.576L2.25037 3.423C2.36442 3.22532 2.54266 3.07259 2.75549 2.99019C2.96832 2.90778 3.20294 2.90066 3.42037 2.97L5.25737 3.555C5.50137 3.375 5.75537 3.207 6.01737 3.055C6.27037 2.913 6.53037 2.784 6.79637 2.669L7.20437 0.787C7.25294 0.564198 7.3762 0.364688 7.55372 0.221549C7.73123 0.0784098 7.95234 0.000239966 8.18037 0H11.8204C12.0484 0.000239966 12.2695 0.0784098 12.447 0.221549C12.6245 0.364688 12.7478 0.564198 12.7964 0.787L13.2084 2.67C13.4884 2.794 13.7624 2.933 14.0274 3.088C14.2744 3.231 14.5134 3.388 14.7434 3.557L16.5814 2.972C16.7987 2.90292 17.0331 2.91017 17.2457 2.99256C17.4583 3.07495 17.6364 3.22753 17.7504 3.425L19.5704 6.578C19.8024 6.985 19.7224 7.5 19.3774 7.817L17.9524 9.117C18.0172 9.70589 18.0172 10.3001 17.9524 10.889L19.3774 12.189C19.7224 12.507 19.8024 13.021 19.5704 13.428L17.7504 16.581C17.6363 16.7787 17.4581 16.9314 17.2453 17.0138C17.0324 17.0962 16.7978 17.1033 16.5804 17.034L14.7434 16.449C14.2665 16.8003 13.752 17.0975 13.2094 17.335L12.7964 19.214C12.7476 19.4366 12.6243 19.6359 12.4468 19.7788C12.2693 19.9218 12.0483 19.9998 11.8204 20ZM9.99637 6C8.93551 6 7.91809 6.42143 7.16795 7.17157C6.4178 7.92172 5.99637 8.93913 5.99637 10C5.99637 11.0609 6.4178 12.0783 7.16795 12.8284C7.91809 13.5786 8.93551 14 9.99637 14C11.0572 14 12.0747 13.5786 12.8248 12.8284C13.5749 12.0783 13.9964 11.0609 13.9964 10C13.9964 8.93913 13.5749 7.92172 12.8248 7.17157C12.0747 6.42143 11.0572 6 9.99637 6Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <p className="cursor-pointer">Settings</p>
            </div>
            <div className="flex content">
              <p className="svg">
                <svg
                  style={{ marginLeft: "-5px" }}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 13V11H7V8L2 12L7 16V13H16Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                  <path
                    d="M20 3H11C9.897 3 9 3.897 9 5V9H11V5H20V19H11V15H9V19C9 20.103 9.897 21 11 21H20C21.103 21 22 20.103 22 19V5C22 3.897 21.103 3 20 3Z"
                    fill={
                      store.color === Colors.allopathic
                        ? HexColors.allopathic
                        : store.color === Colors.homeopathic
                        ? HexColors.homeopathic
                        : HexColors.ayurvedic
                    }
                  />
                </svg>
              </p>
              <Popconfirm
                title="You will be loggedd out!!"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={confirm}
                onCancel={cancel}
                okText="Confirm"
                cancelText="Cancel"
              >
                <p className="cursor-pointer">Log Out</p>
              </Popconfirm>
            </div>
          </div>
        </div>
      </div>
    );
  })
);

export default Doctorsidebar;
